import {v4 as uuidv4} from 'uuid';

import {ensighten} from 'shared/Ensighten/components';
import {APP_LOCAL_STORAGE_OKTA_TOKEN_STORAGE} from 'shared/Storage/constants/localStorageKeys';
import {
  GW_SESSION_UUID_KEY,
  SESSION_STORAGE_NAMESPACE,
  SESSION_STORAGE_NAMESPACE_QUOTING
} from 'types/SessionNamespace';

export const MINUTE_MS = 60000;
export const TIMEOUT_WARNING_MINUTES = 15;
export const TIMEOUT_LOGOUT_MINUTES = 19;

export const getSessionUUID = (): string | null => sessionStorage.getItem(GW_SESSION_UUID_KEY);

export const setSessionUUID = () => {
  const uuid = getSessionUUID();
  if (!uuid) {
    sessionStorage.setItem(GW_SESSION_UUID_KEY, uuidv4());
  }
};

export const clearSessionData = () => {
  window.localStorage.removeItem(APP_LOCAL_STORAGE_OKTA_TOKEN_STORAGE);
  window.sessionStorage.removeItem(SESSION_STORAGE_NAMESPACE);
  window.sessionStorage.removeItem(SESSION_STORAGE_NAMESPACE_QUOTING);

  ensighten.clearVisitorData();
};

export const terminateUnauthenticatedSession = (redirectURL: string) => {
  clearSessionData();
  window.location.replace(redirectURL);
};
